import React from 'react'

const AgeLists = (props) => (
    props.ages.map((age, index) => {
        return <span key={index}>{`${age}${index+1 !== props.ages.length ? ', ' : ''}`}</span>
    })
);

export default AgeLists;
